import React from 'react';
import { useDisabledWidget } from '@wix/chat-widget-common-widgets';
import { Box, Button } from '@wix/design-system';
// import { useUouLanguage } from '../../../hooks/useUouLanguage';
import { AssistantWidgetComponent } from '../types';
import { MessageDisplay } from './components/MessageDisplay';

export const NOWNIA_FALLBACK_WIDGET = 'NOWNIA_FALLBACK_WIDGET';

export const NowniaFallbackWidget: AssistantWidgetComponent = ({ context, data }) => {
  // const language = useUouLanguage();
  const { onRetry } = context;
  const { areControlsDisabled } = useDisabledWidget({ widgetName: NOWNIA_FALLBACK_WIDGET, context, config: data.config });

  return (
    <MessageDisplay
      message={
        areControlsDisabled
          ? ''
          : "Something unexpected happened. I'm not sure what it is, but I'm on it. If you want you can try again or reach out for assistance."
      }
    >
      <Box marginTop={2}>
        <Button skin="dark" size="small" onClick={onRetry} disabled={areControlsDisabled}>
          Try Again
        </Button>
      </Box>
    </MessageDisplay>
  );
};
